export default __webpack_public_path__ + "static/board-approves-luries-family-zoning-fc99b3fe10a66b971e5a2ab4e696343c.png";